import logo from './logo.svg';
import React, { useEffect } from "react";
import { HashRouter as Router, Route, Routes } from "react-router-dom";

import Dashboard from "./components/Dashboard";
import Category from "./components/Category";
import SubCategory from "./components/SubCategory";
import Banner from "./components/Banner";
import ContactEnquiry from "./components/ContactEnquiry";
import Brand from "./components/Brand";
import Model from "./components/Model";
import Medicinetype from "./components/Medicinetype";
import PrivateRoute from "./components/PrivateRoute";
import Users from "./components/Users";

import BlogCategory from "./components/BlogCategory";
import Blog from "./components/Blog";

import ProductList from "./components/Product/ProductList";
import ProductAdd from "./components/Product/ProductAdd";
import ProductEdit from "./components/Product/ProductEdit";

import "bootstrap/dist/css/bootstrap.min.css";
import OrderList from "./components/OrderList";
import TrackOrder from "./components/TrackOrder";
import Login from "./components/Login";

import Department from "./components/Department";
import Specialization from "./components/Specialization";
import Clinic from "./components/Clinic";
import Treatment from "./components/Treatment";
import Coupon from "./components/Coupon";

import DoctorList from "./components/Doctor/DoctorList";
import DoctorAdd from "./components/Doctor/DoctorAdd";
import DoctorEdit from "./components/Doctor/DoctorEdit";
import DoctorAvailablity from "./components/Doctor/DoctorAvailablity";
import DoctorBookings from './components/Doctor/DoctorBookings';
import Settings from './components/Settings';
import Reviews from './components/Reviews';
import Events from './components/Events';
import Camps from './components/Camps';
import AwarenessDays from './components/AwarenessDays';
import EventDetail from './components/EventDetail';

import ScrollToTop from "./components/ScrollToTop";

import './App.css';


function loadAssets(files) {
  files.forEach(file => {
    if (file.endsWith(".css")) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = file;
      document.head.appendChild(link);
    } else if (file.endsWith(".js")) {
      const script = document.createElement("script");
      script.src = file;
      script.async = false;
      document.body.appendChild(script);
    }
  });
}

function App() {
  useEffect(() => {
    loadAssets([
      "./assets/libs/select2/css/select2.min.css",
      "./assets/libs/simplebar/simplebar.min.css",
      "./assets/css/bootstrap.min.css",
      "./assets/css/icons.min.css",
      "./assets/css/app.min.css",

      "./assets/libs/bootstrap/js/bootstrap.bundle.min.js",
      "./assets/libs/jquery/jquery.min.js",
      "./assets/libs/metismenu/metisMenu.min.js",
      "./assets/libs/simplebar/simplebar.min.js",
      "./assets/libs/eva-icons/eva.min.js",
      "./assets/js/scroll-top.init.js",
      "./assets/libs/select2/js/select2.min.js",
      "./assets/libs/apexcharts/apexcharts.min.js",
      "./assets/js/progress-bar.js",
      "./assets/js/dashboard/index.init.js",
      "./assets/js/app.js"
    ]);
  }, []);

  return (

    <Router>
      <ScrollToTop />
      <Routes>

        <Route path="/" element={<Login />} />

        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/category" element={<PrivateRoute><Category /></PrivateRoute>} />
        <Route path="/subcategory" element={<PrivateRoute><SubCategory /></PrivateRoute>} />
        <Route path="/banner" element={<PrivateRoute><Banner /></PrivateRoute>} />
        <Route path="/contact-enquiry" element={<PrivateRoute><ContactEnquiry /></PrivateRoute>} />
        <Route path="/brand" element={<PrivateRoute><Brand /></PrivateRoute>} />
        <Route path="/model" element={<PrivateRoute><Model /></PrivateRoute>} />
        <Route path="/medicinetype" element={<PrivateRoute><Medicinetype /></PrivateRoute>} />

        <Route path="/blogcategory" element={<PrivateRoute><BlogCategory /></PrivateRoute>} />
        <Route path="/blog" element={<PrivateRoute><Blog /></PrivateRoute>} />

        <Route path="/product" element={<ProductList />} />
        <Route path="/product/add" element={<ProductAdd />} />
        <Route path="/product/edit/:id" element={<ProductEdit />} />

        <Route path="/orderlist" element={<OrderList />} />
        <Route path="/trackorder/:orderid" element={<TrackOrder />} />

        <Route path="/department" element={<PrivateRoute><Department /></PrivateRoute>} />
        <Route path="/specialization" element={<PrivateRoute><Specialization /></PrivateRoute>} />
        <Route path="/clinic" element={<PrivateRoute><Clinic /></PrivateRoute>} />
        <Route path="/treatment" element={<PrivateRoute><Treatment /></PrivateRoute>} />
        <Route path="/coupon" element={<PrivateRoute><Coupon /></PrivateRoute>} />

        <Route path="/doctor" element={<DoctorList />} />
        <Route path="/doctor/add" element={<DoctorAdd />} />
        <Route path="/doctor/edit/:id" element={<DoctorEdit />} />
        <Route path="/doctor/availablity/:id" element={<DoctorAvailablity />} />
        <Route path="/doctor-bookings" element={<DoctorBookings />} />
        <Route path="/settings/:id" element={<Settings />} />
        <Route path="/reviews" element={<PrivateRoute><Reviews /></PrivateRoute>} />
        <Route path="/users" element={<PrivateRoute><Users /></PrivateRoute>} />
        <Route path="/events" element={<Events />} />
        <Route path="/camps" element={<Camps />} />
        <Route path="/awareness-days" element={<AwarenessDays />} />
        <Route path="/eventDetail/:id" element={<EventDetail />} />

      </Routes>
    </Router>
  );
}
/*App Location*/
export default App;